import { createAction, props } from '@ngrx/store';
import { TrendingTag } from '../../modals/recogntion.tags';

export interface PageQuery {
  pageIndex: number;
  pageSize: number;
}

export const trendingTagsRequested = createAction(
  '[TRENDING_TAGS] Trending Tags Requested',
  props<{ query: PageQuery }>()
);

export const trendingTagsLoaded = createAction(
  '[TRENDING_TAGS] Trending Tags Loaded',
  props<{ trendingTagList: TrendingTag[], hasNextPage: boolean }>()
);

export const trendingTagsLoadingError = createAction(
  '[TRENDING_TAGS] Trending Tags Loading Error',
  props<{ errorMessage: string }>()
);
